/**
 * @generated SignedSource<<95aab5ee0e52e29ff21d703860b4577e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type APIKeysQuery$variables = {};
export type APIKeysQuery$data = {
  readonly apiKeys: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: string | null;
        readonly id: string;
        readonly name: string;
      } | null;
    } | null>;
  } | null;
};
export type APIKeysQuery = {
  response: APIKeysQuery$data;
  variables: APIKeysQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "APIKeyConnection",
    "kind": "LinkedField",
    "name": "apiKeys",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "APIKeyEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "APIKey",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "APIKeysQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "APIKeysQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4a5f577b8021ac17c8a58bc131673e83",
    "id": null,
    "metadata": {},
    "name": "APIKeysQuery",
    "operationKind": "query",
    "text": "query APIKeysQuery {\n  apiKeys {\n    edges {\n      node {\n        id\n        name\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53b82383e588748be062010536a4bb54";

export default node;
